import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { PostHogProvider } from '@posthog/react';
import './i18n';
import { POSTHOG_KEY, posthogOptions } from './services/posthog';
import App from './App';
// Self-hosted fonts. Previously loaded from Google Fonts, which sent every
// visitor's IP and user-agent to Google on each page load (GDPR audit NC-07).
// Family names match what the CSS already expects: 'Inter', 'Instrument Serif'.
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import '@fontsource/instrument-serif/400-italic.css'
import 'flag-icons/css/flag-icons.min.css'
import './index.css';

// The production Vercel host also serves the app: send people to kableapp.com,
// the origin the API and the magic links accept (audit S-38). /print/ stays
// reachable there for the server-side PDF renderer; preview hosts are untouched.
if (window.location.hostname === 'saas-bank-signatories.vercel.app' && !window.location.pathname.startsWith('/print/')) {
  window.location.replace(`https://kableapp.com${window.location.pathname}${window.location.search}${window.location.hash}`);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <PostHogProvider apiKey={POSTHOG_KEY} options={posthogOptions}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </PostHogProvider>
);
